<template>
  <div class="" v-if="quote && getVersionQuote">
    <TopBarTitleComponent title="Cotizaciones" :showBackIcon="true">
      <template slot="right-area">
        <div class="d-flex justify-content-end align-items-center">
          <!-- <button class="btn md__btn-third-secondary mr-4">Ver Adjuntos</button> -->
          <button
            v-if="canConvertToInvoice"
            class="topbar-action-btn"
            @click="handleCommand('quote-to-invoice')"
            title="Convertir en factura"
          >
            <i class="el-icon-document-checked"></i>
          </button>
          <button
            class="topbar-action-btn"
            :class="{
              'topbar-action-btn--reminder-on': quote.enable_reminders
            }"
            :title="
              quote.enable_reminders
                ? 'Pausar recordatorios'
                : 'Activar recordatorios'
            "
            @click="toggleReminders(!quote.enable_reminders)"
          >
            <i class="el-icon-bell"></i>
          </button>
          <button
            class="topbar-action-btn"
            @click="handleCommand('quote-send')"
            title="Enviar documento"
          >
            <i class="el-icon-s-promotion"></i>
          </button>
          <button
            class="topbar-action-btn"
            @click="handleCommand('quote-download')"
            title="Descargar PDF"
          >
            <i class="el-icon-download"></i>
          </button>
          <el-dropdown
            @command="handleCommand"
            class="d-flex align-items-center"
          >
            <button class="topbar-action-btn">
              <i class="el-icon-more"></i>
            </button>
            <el-dropdown-menu slot="dropdown">
              <template v-if="isStatusDraft || isStatusPending">
                <el-dropdown-item command="quote-edit"
                  ><img :src="iconEdit" alt="" /> Editar</el-dropdown-item
                >
                <el-dropdown-item
                  command="quote-change-status-pending"
                  v-if="isStatusDraft"
                  ><img :src="iconDisapproved" alt="" /> Cambiar a
                  pendiente</el-dropdown-item
                >
                <el-dropdown-item command="quote-delete" v-if="isStatusDraft"
                  ><img :src="iconDelete" alt="" /> Eliminar</el-dropdown-item
                >
              </template>
              <el-dropdown-item
                v-if="canCloseManually"
                command="quote-change-status-success"
                divided
              >
                <i class="el-icon-circle-check" style="margin-right:6px"></i>
                Marcar como aprobada</el-dropdown-item
              >
              <el-dropdown-item
                v-if="canCloseManually"
                command="quote-change-status-deny"
              >
                <i class="el-icon-circle-close" style="margin-right:6px"></i>
                Marcar como no aprobada</el-dropdown-item
              >
              <el-dropdown-item command="quote-history-email" divided>
                <img :src="iconHistory" alt="" /> Historial
                envio</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
    </TopBarTitleComponent>
    <b-container fluid class="pb-4 px-lg-4">
      <b-row>
        <b-col>
          <AlertInfoComponent
            title="Ventas"
            :description="apiResponse.message"
            v-if="apiResponse.message"
            @alertClose="onAlertClose"
            class="mb-4"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <QuoteListVersionsComponent
            :quote="quote"
            @onClickVersion="handleOnClickVersion"
          />
        </b-col>
      </b-row>
      <b-row v-if="quote">
        <b-col>
          <QuoteTimeline :quoteId="quote.id" class="mb-3 mt-2" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div
            class="card box-shadow card-quotes-view py-4"
            v-if="apiResponse.success"
          >
            <div class="card-body">
              <div class="card-quotes-view-header">
                <!-- Mobile header (oculto en desktop) -->
                <DocumentViewHeader
                  class="d-block d-md-none"
                  doc-type="Cotización"
                  :doc-number="quote.code"
                  :business="{
                    logo: getUser.user_business.business_logo,
                    name: getVersionQuote.name,
                    ruc: getUser.user_business.business_ruc
                  }"
                  :date="getVersionQuote.date_at"
                  :status="quote.status"
                  :client="{
                    name: contactName,
                    document: quote.client.document || '',
                    email: quote.client.email || ''
                  }"
                  :meta-items="[
                    { label: 'Validez', value: getVersionQuote.validate_at },
                    {
                      label: 'Versión',
                      value: 'v' + getVersionQuote.version_number
                    }
                  ]"
                />

                <!-- Desktop header (oculto en mobile) -->
                <b-row class="d-none d-md-flex">
                  <b-col sm="12" md="12" lg="6">
                    <div class="card-quotes-view-logo mb-4">
                      <b-row>
                        <b-col sm="12" md="5" lg="4">
                          <div class="logo">
                            <img
                              v-if="getUser.user_business.business_logo"
                              :src="getUser.user_business.business_logo"
                              class="image"
                              id="image-business"
                              alt="Empresa"
                              style="width: 100%; max-width: 200px; height: auto;"
                            />
                          </div>
                        </b-col>
                        <b-col sm="12" md="7" lg="8">
                          <div class="info">
                            <p class="mb-2 text-color-secondary font-bold">
                              Versión: {{ getVersionQuote.version_number }}
                            </p>
                            <h4 class="h4 font-bold m-0">
                              N° {{ quote.code }}
                            </h4>
                            <h2 class="h2 font-bold m-0">
                              {{ getVersionQuote.name }}
                            </h2>
                            <p class="font-semi-bold mt-2">
                              RUC: {{ getUser.user_business.business_ruc }}
                            </p>
                            <p class="font-semi-bold">
                              {{ getUser.user_business.business_address }}
                            </p>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                  <b-col sm="12" md="12" lg="6">
                    <div class="card-quotes-view-info">
                      <b-row>
                        <b-col sm="4" md="4" lg="4">
                          <label class="font-semi-bold d-block">Emisión</label>
                          <p class="m-0">{{ getVersionQuote.date_at }}</p>
                        </b-col>
                        <b-col sm="4" md="4" lg="4">
                          <label class="font-semi-bold d-block">Validez</label>
                          <p class="m-0">{{ getVersionQuote.validate_at }}</p>
                        </b-col>
                        <b-col sm="4" md="4" lg="4">
                          <label class="font-semi-bold d-block mb-2"
                            >Status</label
                          >
                          <StatusReadDocumentsComponent
                            :status="quote.status"
                          />
                        </b-col>
                      </b-row>
                      <b-row class="mt-4">
                        <b-col sm="4" md="4" lg="4">
                          <label class="font-semi-bold d-block">Contacto</label>
                          <p class="m-0">{{ contactName }}</p>
                        </b-col>
                        <b-col sm="4" md="4" lg="4">
                          <label class="font-semi-bold d-block"
                            >Dirección</label
                          >
                          <p class="m-0">{{ quote.client.address }}</p>
                        </b-col>
                        <b-col sm="4" md="4" lg="4">
                          <label class="font-semi-bold d-block">Teléfono</label>
                          <p class="m-0">
                            {{ getUser.user_business.business_phone }}
                          </p>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="card-quotes-view-body mt-3">
                <div class="card-quotes-view-body-products">
                  <!-- Desktop: tabla con columnas (oculto en mobile) -->
                  <div class="d-none d-md-block">
                    <div class="card-quotes-view-table table-items">
                      <b-row class="table-items-header">
                        <b-col md="1">
                          <h6 class="h6 font-bold mb-0 ml-2">Código</h6>
                        </b-col>
                        <b-col md="5">
                          <h6 class="h6 font-bold mb-0">Detalle</h6>
                        </b-col>
                        <b-col md="2">
                          <h6 class="h6 font-bold mb-0">Cantidad</h6>
                        </b-col>
                        <b-col md="2">
                          <h6 class="h6 font-bold mb-0">Precio U.</h6>
                        </b-col>
                        <b-col md="2">
                          <h6 class="h6 font-bold mb-0">Subtotal</h6>
                        </b-col>
                      </b-row>
                    </div>
                    <b-row
                      class="mt-4 d-flex"
                      v-for="(product, index) in getVersionQuote.products"
                      :key="'d' + index"
                    >
                      <b-col md="1">
                        <p class="m-0 ml-2">{{ product.product.code }}</p>
                      </b-col>
                      <b-col md="5">
                        <p class="m-0">
                          <strong>{{ product.product.name }}</strong>
                          <span
                            v-if="product.product_detail"
                            v-html="product.product_detail"
                            class="text-pre-wrap d-block mt-1 text-muted"
                          ></span>
                        </p>
                      </b-col>
                      <b-col md="2">
                        <p class="m-0">{{ product.product_quantity }}</p>
                      </b-col>
                      <b-col md="2">
                        <p class="m-0">${{ product.product_amount }}</p>
                      </b-col>
                      <b-col md="2">
                        <p class="m-0">
                          ${{
                            handleCalculateSubTotal(
                              product.product_quantity,
                              product.product_amount
                            )
                          }}<span
                            v-if="getVersionQuote.hide_total"
                            class="plus-iva"
                            >+IVA</span
                          >
                        </p>
                      </b-col>
                    </b-row>
                  </div>

                  <!-- Mobile: tarjetas por ítem -->
                  <div class="d-block d-md-none doc-mobile-items">
                    <div
                      v-for="(product, index) in getVersionQuote.products"
                      :key="'m' + index"
                      class="doc-item"
                    >
                      <div class="doc-item-row">
                        <span class="doc-item-name">{{
                          product.product.name
                        }}</span>
                        <span class="doc-item-total">
                          ${{
                            handleCalculateSubTotal(
                              product.product_quantity,
                              product.product_amount
                            )
                          }}<span
                            v-if="getVersionQuote.hide_total"
                            class="plus-iva"
                            >+IVA</span
                          >
                        </span>
                      </div>
                      <div v-if="product.product.code" class="doc-item-sku">
                        SKU: {{ product.product.code }}
                      </div>
                      <div class="doc-item-qty">
                        Cant: {{ product.product_quantity }} × ${{
                          product.product_amount
                        }}
                      </div>
                      <div
                        v-if="product.product_detail"
                        v-html="product.product_detail"
                        class="doc-item-detail text-pre-wrap"
                      ></div>
                    </div>
                  </div>
                </div>

                <!-- Mobile: totals + payment + especificaciones (con estilo card) -->
                <div class="d-block d-md-none">
                  <DocumentCalculator
                    readOnly
                    :setProducts="getVersionQuote.products"
                    :setDisc="getVersionQuote.discount"
                    :setHideTotal="!!getVersionQuote.hide_total"
                  />

                  <!-- Forma de pago — card estilo desktop -->
                  <div class="card-quotes-view-method-pay mt-4 p-4">
                    <p class="font-semi-bold mb-2">Forma de pago</p>
                    <p class="m-0" v-if="getVersionQuote.method_payment === 1">
                      De contado
                    </p>
                    <div v-if="getVersionQuote.method_payment === 2">
                      <p class="m-0">Crédito</p>
                      <p class="m-0 text-muted" v-if="getLimitCredit">
                        {{ getLimitCredit.label }}
                        {{ getVersionQuote.limit_credit_at }}
                      </p>
                    </div>
                    <div v-if="getVersionQuote.method_payment === 3">
                      <p
                        class="m-0"
                        v-if="!parsedPaymentData.installments.length"
                      >
                        Anticipo / Contra entrega
                      </p>
                      <p
                        class="m-0 text-muted"
                        v-if="parsedPaymentData.text"
                        style="white-space: pre-line;"
                      >
                        {{ parsedPaymentData.text }}
                      </p>
                      <div
                        v-if="parsedPaymentData.installments.length"
                        class="installments-detail"
                      >
                        <div
                          v-for="(inst, idx) in parsedPaymentData.installments"
                          :key="'mob-inst-' + idx"
                          class="installment-row"
                        >
                          <div class="installment-info">
                            <span class="installment-label">{{
                              inst.label
                            }}</span>
                            <span class="installment-pct"
                              >{{ inst.percentage }}%</span
                            >
                          </div>
                          <span class="installment-amount"
                            >${{ onParseFloatFormat(inst.amount) }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Especificaciones adicionales — card gris estilo desktop -->
                  <div
                    v-if="
                      getVersionQuote.additional_specifications &&
                        getVersionQuote.additional_specifications.length
                    "
                    class="card-quotes-view-aditionals bg-color-gray p-4 mt-4"
                  >
                    <p class="font-semi-bold">Especificaciones Adicionales</p>
                    <div
                      v-for="(specification,
                      index) in getVersionQuote.additional_specifications"
                      :key="'mob-spec-' + index"
                      class="my-1"
                    >
                      - {{ specification }}
                    </div>
                  </div>
                </div>

                <hr class="d-none d-md-block" />
                <!-- Desktop: full layout -->
                <b-row class="d-none d-md-flex">
                  <b-col xs="12" sm="12" md="6">
                    <div class="card-quotes-view-aditionals bg-color-gray p-4">
                      <p class="font-semi-bold">Especificaciones Adicionales</p>
                      <b-row
                        class="my-2"
                        v-for="(specification,
                        index) in getVersionQuote.additional_specifications"
                        :key="index"
                      >
                        <b-col xs="10" sm="10" md="10"
                          >- {{ specification }}</b-col
                        >
                      </b-row>
                    </div>
                    <div class="card-quotes-view-method-pay mt-4 p-4">
                      <p class="font-semi-bold mb-2">Forma de pago</p>
                      <p
                        class="m-0"
                        v-if="getVersionQuote.method_payment === 1"
                      >
                        De contado
                      </p>
                      <div v-if="getVersionQuote.method_payment === 2">
                        <p class="m-0">Crédito</p>
                        <p class="m-0 text-muted" v-if="getLimitCredit">
                          {{ getLimitCredit.label }}
                          {{ getVersionQuote.limit_credit_at }}
                        </p>
                      </div>
                      <div v-if="getVersionQuote.method_payment === 3">
                        <p
                          class="m-0"
                          v-if="!parsedPaymentData.installments.length"
                        >
                          Anticipo / Contra entrega
                        </p>
                        <p
                          class="m-0 text-muted"
                          v-if="parsedPaymentData.text"
                          style="white-space: pre-line;"
                        >
                          {{ parsedPaymentData.text }}
                        </p>
                        <div
                          v-if="parsedPaymentData.installments.length"
                          class="installments-detail"
                        >
                          <div
                            v-for="(inst,
                            idx) in parsedPaymentData.installments"
                            :key="'inst-' + idx"
                            class="installment-row"
                          >
                            <div class="installment-info">
                              <span class="installment-label">{{
                                inst.label
                              }}</span>
                              <span class="installment-pct"
                                >{{ inst.percentage }}%</span
                              >
                            </div>
                            <span class="installment-amount"
                              >${{ onParseFloatFormat(inst.amount) }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col xs="12" sm="12" md="4" offset-md="2">
                    <DocumentCalculator
                      readOnly
                      :setProducts="getVersionQuote.products"
                      :setDisc="getVersionQuote.discount"
                      :setHideTotal="!!getVersionQuote.hide_total"
                    />
                  </b-col>
                </b-row>
              </div>
              <!-- <div
                class="card-quotes-view-footer bg-color-primary py-0 border-radius mt-4"
              >
                <h3 class="h3 font-weight-bold text-center py-3">
                  www.mydessk.com
                </h3>
              </div> -->
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <WrapperSendDocumentDrawer
      @onDocumentSend="onDocumentSend"
      @onCloseDrawer="onCloseDocumentSendDrawer"
      :visibleDocumentSend="visibleDocumentSend"
      :toMails="toMails"
      :toPhone="toPhone"
      :clientId="quote && quote.client ? quote.client.id : null"
      :recipientName="quote && quote.client ? quote.client.name : ''"
      :messageableType="'quote'"
      :messageableId="$route.params.id"
      :moduleType="'quote'"
      :draftKey="'draft-quote-' + $route.params.id"
    />

    <!-- Dialog convertir a factura -->
    <el-dialog
      title=""
      :visible.sync="showConvertDialog"
      append-to-body
      custom-class="confirm-modal"
    >
      <h4 class="h4 text-center font-semi-bold text-break text-color-primary">
        ¿Enviar documento a facturación?
      </h4>
      <SelectEmissionPointsComponent
        @onChangeSelect="
          ({ emissionPointId }) => (convertEmissionPointId = emissionPointId)
        "
        class="my-4"
      />

      <!-- Selector de cuotas (solo anticipo) -->
      <div v-if="convertInstallments.length > 0" class="qtc-installments">
        <p class="qtc-installments__title">Selecciona la cuota a facturar</p>
        <div class="qtc-installments__list">
          <div
            v-for="inst in convertInstallments"
            :key="inst.id"
            class="qtc-inst-card"
            :class="{
              'qtc-inst-card--selected': selectedInstallmentId === inst.id,
              'qtc-inst-card--invoiced': inst.is_invoiced
            }"
            @click="!inst.is_invoiced && (selectedInstallmentId = inst.id)"
          >
            <div class="qtc-inst-card__left">
              <span v-if="inst.is_invoiced" class="qtc-inst-card__check">
                <i class="el-icon-check"></i>
              </span>
              <span
                v-else
                class="qtc-inst-card__radio"
                :class="{ active: selectedInstallmentId === inst.id }"
              ></span>
              <div>
                <span class="qtc-inst-card__label">{{ inst.label }}</span>
                <span
                  v-if="inst.is_invoiced && inst.invoice"
                  class="qtc-inst-card__invoice-ref"
                >
                  Factura #{{ inst.invoice.number_invoice }}
                </span>
              </div>
            </div>
            <div class="qtc-inst-card__right">
              <span class="qtc-inst-card__pct">{{ inst.percentage }}%</span>
              <span class="qtc-inst-card__amount"
                >${{ parseFloat(inst.amount).toFixed(2) }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center mt-5">
        <button
          type="button"
          @click="showConvertDialog = false"
          class="btn md__btn-third-secondary mr-4"
        >
          Cancelar
        </button>
        <ButtonPrimaryComponent
          :title="convertInstallments.length ? 'Facturar cuota' : 'Enviar'"
          @onSaveClick="doConvertToInvoice"
        />
      </div>
    </el-dialog>

    <DocumentSendEmailHistory
      @onCloseDrawer="onCloseDocumentSendEmailHistory"
      :visibleDocumentHistoryEmail="visibleDocumentHistoryEmail"
      :emails="getVersionQuote.user_traking_email_document"
    />
  </div>
</template>

<script>
import AlertInfoComponent from "@/components/Alerts/Info";
import TopBarTitleComponent from "../../../../components/TopBarTitle";
import QuoteListVersionsComponent from "../components/QuoteListVersions";
import QuoteTimeline from "../components/QuoteTimeline";
import WrapperSendDocumentDrawer from "../../../../components/WrapperSendDocumentDrawer";
import SelectEmissionPointsComponent from "../../../../components/SelectEmissionPoints";
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import StatusReadDocumentsComponent from "../../../../components/StatusReadDocuments";
import DocumentCalculator from "../../../components/DocumentCalculator";
import DocumentSendEmailHistory from "../../../components/DocumentSendEmailHistory";
import DocumentViewHeader from "../../../components/DocumentViewHeader";

import quoteService from "../services/quoteService";
import { parseFloatFormat } from "@/assets/utils/format";
import { limitCredits } from "../assets/resources";
import {
  icoMore,
  iconDownload,
  iconHistory,
  iconSend,
  iconDelete,
  iconDisapproved,
  iconEdit
} from "@/services/resources";
import { downloadFile } from "@/assets/utils/files";
import { signingEventBus } from "@/services/signingEventBus";

export default {
  name: "QuoteViewPage",
  data: () => ({
    icoMore,
    apiResponse: {
      success: false,
      message: null
    },
    idVersion: null,
    quote: null,
    limitCredits,
    iconDownload,
    iconHistory,
    iconSend,
    iconDelete,
    iconDisapproved,
    iconEdit,
    visibleDocumentSend: false,
    visibleDocumentHistoryEmail: false,
    showConvertDialog: false,
    convertEmissionPointId: null,
    convertInstallments: [],
    selectedInstallmentId: null
  }),
  computed: {
    getUser() {
      return this.$store.getters.getUser;
    },
    getLimitCredit() {
      return limitCredits.find(
        limit => this.getVersionQuote.limit_credit === limit.value
      );
    },
    getVersionQuote() {
      return this.quote.versions.find(v => this.idVersion === v.id);
    },
    parsedPaymentData() {
      var obs =
        this.getVersionQuote && this.getVersionQuote.observation_advance;
      if (!obs) return { text: "", installments: [] };

      var lines = obs.split("\n");
      var installments = [];
      var textLines = [];
      var inDetail = false;

      for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim();
        if (line === "Detalle de cuotas:") {
          inDetail = true;
          continue;
        }
        if (inDetail && line.indexOf("- ") === 0) {
          // Parse: "- Anticipo: 40% — $368.00"
          var match = line.match(/^- (.+?):\s*(\d+)%\s*—\s*\$(.+)$/);
          if (match) {
            installments.push({
              label: match[1],
              percentage: parseInt(match[2]),
              amount: parseFloat(match[3])
            });
          }
        } else if (!inDetail && line) {
          textLines.push(line);
        }
      }

      return {
        text: textLines.join("\n"),
        installments: installments
      };
    },
    isStatusDraft() {
      return this.quote.status === "draft";
    },
    isStatusPending() {
      return this.quote.status === "pending";
    },
    // Cierre manual solo mientras la cotización sigue abierta. Una vez facturada
    // (partial/success por factura) el estado lo gobierna la facturación.
    canCloseManually() {
      return ["draft", "pending", "preapproved"].includes(this.quote.status);
    },
    canConvertToInvoice() {
      return ["draft", "pending", "partial", "preapproved"].includes(
        this.quote.status
      );
    },
    contactName() {
      return this.quote.contact
        ? this.quote.contact.name
        : this.quote.client.name;
    },
    toMails() {
      const { client, contact } = this.quote;
      if (contact && contact.email) return [contact.email];
      else if (client && client.email) return [client.email];
      return [];
    },
    toPhone() {
      const { client, contact } = this.quote;
      if (contact && contact.phone) return String(contact.phone).trim();
      if (client && client.phone) return String(client.phone).trim();
      return "";
    }
  },
  methods: {
    toggleApiResponse(property, value) {
      this.apiResponse[property] = value;
    },
    handleCalculateSubTotal(quantity, price) {
      return parseFloatFormat(quantity * price);
    },
    goPage(name) {
      this.$router.push({ name });
    },
    async getQuote(quoteId) {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await quoteService.getQuoteId(quoteId).finally(() => {
          this.$store.dispatch("toggleRequestLoading");
        });
        const { success, quote } = response.data;
        if (success) {
          this.quote = quote;
          this.toggleApiResponse("success", true);
        }
      } catch (error) {
        return false;
      }
    },

    async updateQuoteStatus(status) {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await quoteService
          .updateQuoteStatus(this.quote.id, {
            status
          })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { success, message } = response.data;
        if (success) {
          this.$notifications.success({
            message
          });
          this.quote.status = status;
          // Aprobar/rechazar corta el seguimiento en backend: reflejarlo en la UI.
          if (status === "success" || status === "deny") {
            this.$set(this.quote, "enable_reminders", false);
          }
        }
      } catch (error) {
        this.$notifications.error({
          message:
            error?.response?.data?.message || "Error al actualizar el estado"
        });
        return false;
      }
    },
    async confirmStatusChange(status) {
      const isApprove = status === "success";
      try {
        await this.$confirm(
          isApprove
            ? "La cotización quedará como aprobada y se detendrán los recordatorios. No se genera ninguna factura."
            : "La cotización quedará como no aprobada y se detendrán los recordatorios.",
          isApprove ? "Marcar como aprobada" : "Marcar como no aprobada",
          {
            confirmButtonText: isApprove ? "Sí, aprobar" : "Sí, marcar",
            cancelButtonText: "Cancelar",
            type: "warning"
          }
        );
      } catch (e) {
        return; // cancelado por el usuario
      }
      this.updateQuoteStatus(status);
    },
    async toggleReminders(val) {
      const previous = !!this.quote.enable_reminders;
      this.$set(this.quote, "enable_reminders", val);
      try {
        await quoteService.updateReminders(this.quote.id, {
          enable_reminders: val
        });
        this.$notifications.success({
          message: val
            ? "Recordatorios de seguimiento activados"
            : "Recordatorios de seguimiento pausados"
        });
      } catch (e) {
        this.$set(this.quote, "enable_reminders", previous);
        this.$notifications.error({
          message: "No se pudo actualizar los recordatorios"
        });
      }
    },
    handleOnClickVersion(version) {
      this.idVersion = version.id;
    },
    onParseFloatFormat(value) {
      return parseFloatFormat(value);
    },
    onAlertClose() {
      this.toggleApiResponse("message", "");
    },
    handleCommand(command) {
      switch (command) {
        case "quote-edit":
          this.goPage("sales.quotes.edit");
          break;
        case "quote-send":
          this.visibleDocumentSend = true;
          break;
        case "quote-history-email":
          this.visibleDocumentHistoryEmail = true;
          break;
        case "quote-download":
          this.quoteDownload();
          break;
        case "quote-delete":
          this.quoteDelete();
          break;
        case "quote-change-status-pending":
          this.updateQuoteStatus("pending");
          break;
        case "quote-change-status-success":
          this.confirmStatusChange("success");
          break;
        case "quote-change-status-deny":
          this.confirmStatusChange("deny");
          break;
        case "quote-to-invoice":
          this.convertToInvoice();
          break;
        case "quote-create-signing-doc":
          this.$router.push({
            name: "documentos.sign-flow",
            query: {
              quoteId: this.quote.id,
              quoteName: this.getVersionQuote
                ? `Cotización #${this.quote.code}`
                : "Cotización"
            }
          });
          break;
      }
    },
    async convertToInvoice() {
      if (!this.quote || !this.getVersionQuote) return;

      // Modo "Sin total (+IVA)": no se puede facturar hasta desactivarlo.
      if (this.getVersionQuote.hide_total) {
        this.$notifications.warning({
          message:
            "Esta cotización está en modo sin total (+IVA). Desactiva ese modo editando la cotización para poder emitir la factura."
        });
        return;
      }

      this.showConvertDialog = true;
      this.selectedInstallmentId = null;
      this.convertInstallments = [];

      // Load installments if anticipo
      const version = this.getVersionQuote;
      if (version && parseInt(version.method_payment) === 3 && version.id) {
        try {
          const res = await quoteService.getInstallments(
            this.quote.id,
            version.id
          );
          if (
            res.data &&
            res.data.success &&
            res.data.data &&
            res.data.data.length
          ) {
            this.convertInstallments = res.data.data;
            const firstPending = this.convertInstallments.find(
              i => !i.is_invoiced
            );
            if (firstPending) this.selectedInstallmentId = firstPending.id;
          }
        } catch (e) {
          this.convertInstallments = [];
        }
      }
    },
    async doConvertToInvoice() {
      if (!this.convertEmissionPointId) {
        this.$notifications.warning({
          message: "Selecciona un punto de emisión"
        });
        return;
      }

      this.$store.dispatch("toggleRequestLoading");
      try {
        const version = this.getVersionQuote;
        const client = this.quote.client;

        const payload = {
          user_business_client_id: client.id,
          user_business_e_point_id: this.convertEmissionPointId,
          email: client.email,
          discount: version.discount,
          discount_type: "percentage",
          user_business_quote_id: this.quote.id,
          user_business_quote_v_id: version.id,
          products: version.products
        };

        // Add installment if selected
        if (this.selectedInstallmentId) {
          payload.quote_installment_id = this.selectedInstallmentId;
        }

        let response = await quoteService
          .sendQuoteToInvoice(payload)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { success, message, data } = response.data;
        if (success) {
          this.showConvertDialog = false;
          this.$notifications.success({
            message: message || "Factura creada exitosamente"
          });
          // Avisa a las columnas (facturas y cotizaciones) que hay un documento
          // nuevo y que esta cotización cambió de estado. Sin esto la columna de
          // facturas no muestra la factura recién creada hasta recargar.
          this.$store.dispatch("sendNotification", true);
          if (data && data.id) {
            this.$router
              .push({
                name: "sales.invoices.view",
                params: { id: data.id }
              })
              .catch(() => {});
          }
        }
      } catch (error) {
        return false;
      }
    },
    onCloseDocumentSendDrawer() {
      this.visibleDocumentSend = false;
    },
    onCloseDocumentSendEmailHistory() {
      this.visibleDocumentHistoryEmail = false;
    },
    onDocumentSend({ data }) {
      data.append("quote_id", this.quote.id);
      data.append("quote_version_id", this.idVersion);

      this.sendQuoteEmail({ data });
    },
    async quoteDownload() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await quoteService
          .downloadQuote({
            quoteId: this.quote.id,
            quoteVersionId: this.idVersion
          })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        if (response) {
          downloadFile(response.data, `Cotización - #${this.quote.code}`);
        }
      } catch (error) {
        return false;
      }
    },
    async quoteDelete() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await quoteService
          .deleteQuoteId(this.quote.id)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });

        const { success, message } = response.data;
        if (success) {
          this.$notifications.success({
            message
          });
          this.$emit("onUpdate");
        }
      } catch (error) {
        return false;
      }
    },
    async sendQuoteEmail({ data }) {
      const emailId = `email-quote-${Date.now()}`;
      const clientName = this.quote?.client?.name || "";
      const docNumber = this.quote?.code || "";

      this.visibleDocumentSend = false;

      signingEventBus.$emit("email:start", {
        id: emailId,
        clientName,
        documentNumber: `Cotización #${docNumber}`
      });

      try {
        let response = await quoteService.sendQuoteEmail({ data });
        const { success, message, data: quote } = response.data;
        if (success) {
          this.quote = quote;
          signingEventBus.$emit("email:done", {
            id: emailId,
            clientName,
            documentNumber: `Cotización #${docNumber}`
          });
        } else {
          signingEventBus.$emit("email:error", {
            id: emailId,
            message: message || "Error al enviar el documento"
          });
        }
      } catch (error) {
        signingEventBus.$emit("email:error", {
          id: emailId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al enviar"
        });
      }
    }
  },
  components: {
    TopBarTitleComponent,
    AlertInfoComponent,
    QuoteListVersionsComponent,
    QuoteTimeline,
    StatusReadDocumentsComponent,
    WrapperSendDocumentDrawer,
    SelectEmissionPointsComponent,
    ButtonPrimaryComponent,
    DocumentCalculator,
    DocumentSendEmailHistory,
    DocumentViewHeader
  },
  props: {
    query: {}
  },
  mounted() {
    if (this.query && this.query.quoteSendEmail)
      this.visibleDocumentSend = true;
    const { id: quoteId, idVersion } = this.$route.params;
    this.idVersion = parseInt(idVersion);
    if (quoteId && idVersion) this.getQuote(quoteId);
  }
};
</script>

<style lang="scss" scoped>
.plus-iva {
  font-size: 11px;
  font-weight: 600;
  color: #6c757d;
  margin-left: 4px;
}
.topbar-action-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #31355c;
  transition: all 0.15s;
  margin-right: 4px;

  &:hover {
    background: #f0f2f7;
  }
}
.topbar-action-btn--reminder-on {
  color: #3ecfb4 !important;
  &:hover {
    background: #f0fdfb !important;
  }
}
.card-quotes-view {
  border-radius: 14px;
  border: 1px solid #e8ecf2;
  box-shadow: 0 2px 12px rgba(49, 53, 92, 0.06);

  .card-quotes-view-header {
    .card-quotes-view-logo {
      padding-bottom: 20px;
      border-bottom: 1px solid #e8ecf1;
      p {
        margin: 0;
      }
      .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        img {
          border-radius: 8px;
          max-width: 180px;
        }
      }
      .info {
        h2 {
          color: #31355c;
          line-height: 1.2;
        }
        h4 {
          color: #31355c;
        }
        p {
          color: #6b7280;
          font-size: 13px;
        }
      }
    }

    .card-quotes-view-info {
      padding: 16px 0;
      border-bottom: 1px solid #e8ecf1;
      label {
        font-size: 11px;
        color: #9ca3af;
        font-weight: 400;
        text-transform: none;
        letter-spacing: normal;
        margin-bottom: 2px;
      }
      p {
        color: #31355c;
        font-weight: 600;
        font-size: 14px;
      }
    }
  }

  .card-quotes-view-body-products {
    min-height: 200px;
  }

  .card-quotes-view-aditionals {
    border-radius: 10px;
    border: 1px solid #e8ecf2;
    background: #f9fafb !important;
  }

  .card-quotes-view-method-pay {
    border-radius: 10px;
    border: 1px solid #e8ecf2;
    background: #fff;
  }
}

.installments-detail {
  border-top: 1px solid #eef1f7;
  padding-top: 12px;
}

.installment-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #f8f9fc;
  border-radius: 8px;
  margin-bottom: 6px;

  &:last-child {
    margin-bottom: 0;
  }
}

.installment-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.installment-label {
  font-size: 13px;
  font-weight: 600;
  color: #2d2b55;
}

.installment-pct {
  font-size: 12px;
  color: #989aae;
  font-weight: 500;
}

.installment-amount {
  font-size: 13px;
  font-weight: 700;
  color: #1d9e75;
}

// Mobile: tarjetas de ítems
.doc-mobile-items {
  padding: 0;
}
.doc-mobile-item {
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  &:last-child {
    border-bottom: none;
  }
}
.doc-mobile-item-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.doc-mobile-name {
  font-size: 15px;
  font-weight: 600;
  color: #31355c;
  flex: 1;
  line-height: 1.4;
}
.doc-mobile-price {
  font-size: 15px;
  font-weight: 600;
  color: #31355c;
  white-space: nowrap;
}
.doc-mobile-meta {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
}
.doc-mobile-detail {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
  line-height: 1.5;
}

@media (max-width: 767px) {
  .card-quotes-view {
    border-radius: 0;
    border-left: none;
    border-right: none;
    padding: 0 !important;

    .card-body {
      padding: 20px 16px;
    }
  }
}

// Cuotas selector
.qtc-installments {
  margin-top: 16px;
  &__title {
    font-size: 13px;
    font-weight: 600;
    color: #31355c;
    margin-bottom: 10px;
  }
  &__list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
}
.qtc-inst-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border: 1.5px solid #e8ecf2;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s;
  background: #fff;
  &:hover:not(.qtc-inst-card--invoiced) {
    border-color: #3ecfb4;
    background: #f0fdf9;
  }
  &--selected {
    border-color: #3ecfb4 !important;
    background: #f0fdf9 !important;
  }
  &--invoiced {
    opacity: 0.55;
    cursor: default;
    background: #f9fafb;
  }
  &__left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  &__radio {
    width: 18px;
    height: 18px;
    min-width: 18px;
    border: 2px solid #d1d5db;
    border-radius: 50%;
    transition: all 0.15s;
    &.active {
      border-color: #3ecfb4;
      background: #3ecfb4;
      box-shadow: inset 0 0 0 3px #fff;
    }
  }
  &__check {
    width: 18px;
    height: 18px;
    min-width: 18px;
    background: #1d9e75;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 10px;
  }
  &__label {
    font-size: 13px;
    font-weight: 600;
    color: #31355c;
    display: block;
  }
  &__invoice-ref {
    font-size: 11px;
    color: #1d9e75;
    font-weight: 500;
    display: block;
    margin-top: 1px;
  }
  &__right {
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 1px;
  }
  &__pct {
    font-size: 12px;
    color: #9ca3af;
    font-weight: 500;
  }
  &__amount {
    font-size: 14px;
    font-weight: 700;
    color: #31355c;
  }
}
</style>
